<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <PageForm @submit-requested="submitRequested"></PageForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import PageForm from './PageForm.vue'

  export default {
  components: { PageForm },
  methods: {
    ...mapActions('pages', ['postPage']),
    submitRequested (input) {
      this.postPage(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 